export default [
    {
        path: '/players',
        name: 'PagePlayersList',
        meta: { title: 'players.listTitle', roles: ['ADMIN', 'TEAM_LEADER'], permissions: ['players'] },
        component: () => import('@/pages/players'),
    },
    {
        path: '/players/create',
        name: 'PagePlayersCreate',
        meta: { title: 'players.createFormTitle', roles: ['ADMIN', 'TEAM_LEADER'], permissions: ['players'] },
        component: () => import('@/pages/players/create'),
    },
    {
        path: '/players/:id/edit',
        name: 'PagePlayersEdit',
        meta: { title: 'players.editFormTitle', roles: ['ADMIN', 'TEAM_LEADER'], permissions: ['players'] },
        component: () => import('@/pages/players/id/edit'),
    },
]
